import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import CustomerType from "./actionTypes"
import { IgarashiCustomerAction, OtherCustomerAction } from "./actions"
import {
  IgarashiCustomerAPI,
  OtherCustomerAPI,
} from "helpers/customer_backend_helper"

// get global state
export const getState = ({ Users }) => Users

// // OTHER
function* fetchOtherListOnPage({ payload }) {
  yield put(
    OtherCustomerAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(OtherCustomerAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      OtherCustomerAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      OtherCustomerAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchOtherListHistoryOnPage({ payload }) {
  yield put(
    OtherCustomerAction.getListHistoryPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page - 1
    let { data } = yield call(OtherCustomerAPI.getListHistoryPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      OtherCustomerAction.getListHistoryPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      OtherCustomerAction.getListHistoryPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchOtherDetail({ payload, action }) {
  yield put(
    OtherCustomerAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(OtherCustomerAPI.getDetail, payload.id)

    action(data)
    yield put(
      OtherCustomerAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      OtherCustomerAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchOtherPostData({ payload, action }) {
  yield put(
    OtherCustomerAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(OtherCustomerAPI.postData, payload)

    yield put(
      OtherCustomerAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      OtherCustomerAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchOtherPutData({ payload, action }) {
  yield put(
    OtherCustomerAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    console.log("masuk sini")

    let { data } = yield call(OtherCustomerAPI.putData, payload)

    yield put(
      OtherCustomerAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    yield put(
      OtherCustomerAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

// IGARASHI
function* fetchIgarashiListOnPage({ payload }) {
  console.log(payload)
  yield put(
    IgarashiCustomerAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(IgarashiCustomerAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      IgarashiCustomerAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      IgarashiCustomerAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchIgarashiListHistoryOnPage({ payload }) {
  console.log(payload)
  yield put(
    IgarashiCustomerAction.getListHistoryPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    console.log(payload, "pay")
    const currentPage = payload.page - 1
    let { data } = yield call(IgarashiCustomerAPI.getListHistoryPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      IgarashiCustomerAction.getListHistoryPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error, "er")
    yield put(
      IgarashiCustomerAction.getListHistoryPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchIgarashiDetail({ payload, action }) {
  yield put(
    IgarashiCustomerAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(IgarashiCustomerAPI.getDetail, payload.id)

    action(data)
    yield put(
      IgarashiCustomerAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      IgarashiCustomerAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchIgarashiPostData({ payload, action }) {
  yield put(
    IgarashiCustomerAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(IgarashiCustomerAPI.postData, payload)

    yield put(
      IgarashiCustomerAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      IgarashiCustomerAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchIgarashiPutData({ payload, action }) {
  yield put(
    IgarashiCustomerAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    console.log("masuk sini")

    let { data } = yield call(IgarashiCustomerAPI.putData, payload)

    yield put(
      IgarashiCustomerAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    yield put(
      IgarashiCustomerAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* customerSaga() {
  // OTHER
  yield takeEvery(CustomerType.GET_OTHER_CUSTOMER_PAGES, fetchOtherListOnPage)
  yield takeEvery(
    CustomerType.GET_OTHER_CUSTOMER_HISTORIES_PAGES,
    fetchOtherListHistoryOnPage
  )
  yield takeEvery(
    CustomerType.GET_DETAIL_OTHER_CUSTOMER_BY_ID,
    fetchOtherDetail
  )
  yield takeEvery(CustomerType.POST_OTHER_CUSTOMER, fetchOtherPostData)
  yield takeEvery(CustomerType.PUT_OTHER_CUSTOMER, fetchOtherPutData)

  // IGARASHI

  yield takeEvery(
    CustomerType.GET_IGARASHI_CUSTOMER_PAGES,
    fetchIgarashiListOnPage
  )
  yield takeEvery(
    CustomerType.GET_IGARASHI_CUSTOMER_HISTORIES_PAGES,
    fetchIgarashiListHistoryOnPage
  )
  yield takeEvery(
    CustomerType.GET_DETAIL_IGARASHI_CUSTOMER_BY_ID,
    fetchIgarashiDetail
  )
  yield takeEvery(CustomerType.POST_IGARASHI_CUSTOMER, fetchIgarashiPostData)
  yield takeEvery(CustomerType.PUT_IGARASHI_CUSTOMER, fetchIgarashiPutData)
}

export default customerSaga
